import Vue from 'vue'
import Router from 'vue-router'
import Index from '../view/index'

Vue.use(Router)
const VueRouterPush = Router.prototype.push
Router.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch(err => err)
}

export const routes = [{
    path: '/',
    name: 'Index',
    component: Index,
    redirect: '/Index',
    children: [{
        path: 'Index',
        name: "Index",
        component: () =>
          import ('@/view/Home/index.vue')
      },
      {
        path: 'Call',
        name: "Call",
        component: () =>
          import ('@/view/Call/index.vue')
      },
      {
        path: 'Charpter',
        name: "Charpter",
        component: () =>
          import ('@/view/Charpter/index.vue')
      },
      {
        path: 'Role',
        name: "Role",
        component: () =>
          import ('@/view/Role/index.vue')
      },
      {
        path: 'Part',
        name: "Part",
        component: () =>
          import ('@/view/Charpter/part.vue')
      }, {
        path: 'Space',
        name: "Space",
        component: () =>
          import ('@/view/Space/index.vue')
      }
    ]
  },
  {
    path: "/agreement",
    name: "agreement",
    component: () =>
      import ('@/view/Call/agreement.vue')
  },
  {
    path: "/userAgreement",
    name: "userAgreement",
    component: () =>
      import ('@/view/Call/userAgreement.vue')
  },
  {
    path: "/privacyPolicy",
    name: "privacyPolicy",
    component: () =>
      import ('@/view/Call/privacyPolicy.vue')
  },
  {
    path: "/cPrivacyPolicy",
    name: "cPrivacyPolicy",
    component: () =>
      import ('@/view/Call/cPrivacyPolicy.vue')
  }
]
const router = new Router({
  base: '/',
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition && to.meta.keepAlive) {
      return savedPosition;
    }
    return { x: 0, y: 0 };
  },
});

export default router


// WEBPACK FOOTER //
// ./src/router/index.js